import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Alert,
  FormGroup,
  Modal,
  ModalHeader, ModalBody, ModalFooter
} from "reactstrap"
import { post, put, get } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import PartnerBranch from "../PartnersBranch/AddPartnerBranch"
import { Trans } from "react-i18next"
import { useNavigate, useParams } from "react-router-dom"
import {
  ADD_COLLECTOR,
  SHOW_COLLECTOR,
  UPLOAD_FILE,
  COUNTRIES_SEARCH,
  REMOVE_COLLECTOR,
  LANGUAGES_SEARCH,
  ADD_USER,
  REMOVE_USER,
  ASSIGN_ROLE,
  UPDATE_COLLECTOR,
  PARTNERS_SEARCH
} from "helpers/api_endpoints"
import moment from "moment"
import Select from "react-select"
import { set } from "lodash"


//meta title
document.title = "Add Collector"

const AddCollector = () => {
  const [status, setStatus] = useState(1)
  const [name, setName] = useState('{"title":[{"1":""}]}')
  const [named, setNamed] = useState("")
  const [languages, setLanguages] = useState([])
  const [partners, setPartners] = useState([])
  const [countryCode, setCountryCode] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [email, setEmail] = useState(null)
  const [partnerId, setPartnerId] = useState(null)
  const [password, setPassword] = useState(null)
  const [userId, setUserId] = useState("")
  const [walletBalance, setWalletBalance] = useState([])
  const [countries, setCountries] = useState(() => [
    { value: "0", label: "None" },
  ])
  const [errorMsg, seterrorMsg] = useState([])
  const [loading, setLoading] = useState(false)
  const [isWalletModalOpen, setIsWalletModalOpen] = useState(false)
  const navigate = useNavigate()
  const params = useParams()

  useEffect(() => {
    post(`${LANGUAGES_SEARCH}`, { status: 1 })
      .then(response => {
        setLanguages(response.data)
        // console.log(languages);
        setLoading(false)
      })
      .catch(error => {
        console.log(error)
        // navigate('/collhub');
      })
    if(params.id){
      getCollectorData(params.id);
    }
  }, [])

  useEffect(() => {
    getCountries();
    getPartners();
  }, [])

  const getCountries = () => {
      post(`${COUNTRIES_SEARCH}`)
         .then(response =>{
              setCountries([{value:'0',label:'None'}].concat(response.data.map(el=>{
                 return {value:el.countryCode,label:el.countryCode, flagUrl: el.countryCode}
             })));
         })
 };

  const getPartners = () => {
      post(`${PARTNERS_SEARCH}`)
         .then(response =>{
              setPartners([{value:'0',label:'None'}].concat(response.data.map(el=>{
                 return {value:el.id,label:el.name}
             })));
         })
 };

  const getCollectorData = (id) => {
    get(`${SHOW_COLLECTOR}/${id}`)
      .then(response => {
        const data = response.data;
        console.log(data)
        setName(data.name);
        setNamed(data.named);
        setEmail(data.user?.email || '');
        setPhoneNumber(data.user?.mobile.substr(3) || '');
        setCountryCode(data.user.countryCode ? `+${data.user.countryCode}` : '');
        setStatus(data.status);
        setPartnerId(data.partnerId);
        setWalletBalance(data.walletBalance || 0);
      })
      .catch(error => {
        console.log(error)
        navigate('/Collectors');
      })
  }

  const validatePartnerData = () => {
    const errors = []

    if (!name || name === '{"title":[{"1":""}]}') {
      errors.push("Name is required")
    }

    if (!email) {
      errors.push("Email is required")
    }

    if (!password) {
      errors.push("Password is required")
    }
    if (!phoneNumber) {
      errors.push("Phone number is required")
    }


    return errors
  }

  const handleSubmit = () => {
    // Clear previous errors
    seterrorMsg([])

    // Validate all required fields
    const validationErrors = validatePartnerData()

    if (validationErrors.length > 0) {
      seterrorMsg(validationErrors)
      // Scroll to top to show errors
      window.scrollTo({ top: 0, behavior: "smooth" })
      return false
    }
    saveUserData();
  }

  const handleToggleCheckBox = inputFunction => {
    switch (inputFunction) {
      case "setStatus":
        if (status == 1) {
          setStatus(2)
        } else {
          setStatus(1)
        }
        console.log(status)
        break
      default:
        break
    }
  }

  const checkPhoneNumber = (type, value) => {
    const regx1 = /^(50|52|54|55|56|58)\d{7}$/
    const regx2 = /^(02|03|04|05|06|07|08)\d{7}$/

    if (type === 1 && value.length < 9) {
      // onBlur
      if (!regx1.test(value) && !regx2.test(value)) {
        setPhoneNumber("")
        return
      }
    }

    // Only update if the value actually changed
    if (phoneNumber !== value) {
      setPhoneNumber(value)
    }
  }

  const assignCollectorRole = async userId => {
    try {
      // Try to assign the partner role (ID 4)
      const roleResponse = await post(ASSIGN_ROLE, {
        UserId: userId,
        RoleId: 7,
      })

      if (roleResponse.code !== 200 && roleResponse.code !== 201) {
        console.warn(
          "Failed to assign role, but continuing with creation"
        )
      }
    } catch (error) {
      console.warn("Error assigning role:", error.message)
    }
  }

  const saveUserData = async (branchData = null) => {
    let userData = null
    let partnerData = null

    try {
      setLoading(true)
      seterrorMsg([])
      if(params.id){
        put(`${UPDATE_COLLECTOR}`, {
          id: params.id,
          name,
          status,
          partnerId

        });
        navigate("/Collectors", {
          state: { successMsg: "Updated successfully" },
        })
        return;
      }
      // 1. First create the user
      const userResponse = await post(ADD_USER, {
        name: "collector",
        email,
        password,
        mobile: countryCode.replace("+", "") + phoneNumber,
        status: 2,
      })

      if (userResponse.code !== 201 || !userResponse.data?.id) {
        throw new Error("Failed to create user account")
      }

      userData = userResponse.data
      let partnerResponse

      try {
        // 2. Try to assign partner role
        await assignCollectorRole(userData.id)

        // 3. Create partner
        const cleanedCountryCode = countryCode
          ? countryCode.replace("+", "")
          : ""
        const fullPhoneNumber =
          cleanedCountryCode && phoneNumber
            ? `${cleanedCountryCode}${phoneNumber}`
            : phoneNumber

        await post(ADD_COLLECTOR, {
          name,
          phoneNumber: fullPhoneNumber,
          status,
          countryCode: cleanedCountryCode,
          userId: userData.id,
          partnerId
        })

        if (partnerResponse.code !== 201) {
          throw new Error(partnerResponse.message || "Failed to create partner")
        }

        // collectorData = collectorResponse.data


        // If no branch data, just redirect to partners list
        navigate("/Collectors", {
          state: { successMsg: "Added successfully" },
        })
      } catch (error) {
        // Cleanup partially created records
        // Note: Backend uses soft delete, so these records will be marked as deleted

        const errorMessage =
          error?.response?.data?.message || error.message || "An error occurred"
        const errorArray = Array.isArray(errorMessage)
          ? errorMessage
          : [errorMessage]

        const hasUniqueError = errorArray.some(
          msg =>
            msg &&
            (msg.includes("already in use") ||
              msg.includes("already exists") ||
              msg.includes("unique"))
        )

        if (hasUniqueError) {
          errorArray.push(
            "Note: If you previously attempted to create this partner and it failed, you may need to use different email/phone or contact support to restore the previous record."
          )
        }

        seterrorMsg(prev => [
          ...new Set([...prev, ...errorArray.filter(Boolean)]),
        ])
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error.message ||
        "Failed to create partner"
      seterrorMsg(prev =>
        [
          ...prev,
          ...(Array.isArray(errorMessage) ? errorMessage : [errorMessage]),
        ].filter(Boolean)
      )
    } finally {
      setLoading(false)
    }
  }

  const handleCountryCode = countryCode => {
    setCountryCode(countryCode)
  }

  const setCollector = branchData => {
    saveUserData(branchData)
  }

  const handleFileUpload = event => {
    setLoading(true)
    const file = event.target.files[0]
    post(
      `${UPLOAD_FILE}`,
      { file, type: "partners", fullPath: "true" },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then(response => {
        const data = response.data
        setLicenseFilePath(data.path)
        setLoading(false)
      })
      .catch(error => {})
  }

  const handleName = (languageId, value) => {
    if (!named.title) {
      setNamed({ title: [{ 1: value }] })
      return
    }
    const ln = named.title.filter(el => {
      return Object.keys(el)[0] == languageId
    })

    if (ln == undefined || ln.length < 1) {
      const ob = {}
      ob[languageId] = value
      named.title.push(ob)
    } else {
      ln[0][languageId] = value
    }
    setName(JSON.stringify(named))
  }



  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Collectors" breadcrumbItem="Add Collector" />
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              // handleSubmit();
              return false
            }}
          >
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <Row>

                      {errorMsg.length > 0 && (
                        <Alert color="danger">
                          {errorMsg.map((msg, idx) => (
                            <li key={idx}>{msg}</li>
                          ))}
                        </Alert>
                      )}

                      {languages.map((language, index) => (
                        <div className="form-group col-md-3 mt-2" key={index}>
                          <Label className="form-label">
                            <Trans>Name ({language.name})</Trans>
                          </Label>
                          <Input
                            name="name"
                            value={
                              named.title
                                ? named.title.find(el => {
                                    return el[language.id]
                                  })
                                  ? named.title.find(el => {
                                      return el[language.id]
                                    })[language.id]
                                  : ""
                                : ""
                            }
                            className="form-control"
                            placeholder="Enter Name"
                            type="text"
                            onChange={e =>
                              handleName(language.id, e.target.value)
                            }
                            required={
                              language.id == 1 || language.id == 2
                                ? true
                                : false
                            }
                          ></Input>
                          <Input type="hidden" name="id"></Input>
                        </div>
                      ))}

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Email</Trans>
                        </Label>
                        <Input
                          name="email"
                          value={email}
                          className="form-control"
                          placeholder="Enter Email"
                          type="email"
                          autoComplete="off"
                          onChange={e => setEmail(e.target.value)}
                          required
                        ></Input>
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Password</Trans>
                        </Label>
                        <Input
                          name="password"
                          className="form-control"
                          placeholder="Enter Password"
                          type="password"
                          autoComplete="false"
                          onChange={e => setPassword(e.target.value)}
                          required
                        ></Input>
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Country Code</Trans>
                        </Label>
                        <Select
                          name="countryCode"
                          value={
                            countryCode
                              ? countries.find(el => el.value === countryCode)
                              : null
                          }
                          options={countries}
                          className="form-control select2"
                          onChange={e => handleCountryCode(e.value)}
                        />
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Phone Number</Trans>
                        </Label>
                        <Input
                          name="phoneNumber"
                          value={phoneNumber}
                          className="form-control"
                          placeholder="Enter Phone Number"
                          type="text"
                          onBlur={e => checkPhoneNumber(1, e.target.value)}
                          onChange={e => checkPhoneNumber(2, e.target.value)}
                          required
                        ></Input>
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Partner</Trans>
                        </Label>
                        <Select
                          name="partnerId"
                          value={
                            partners.find(el => el.value === partnerId)
                          }
                          options={partners}
                          className="form-control select2"
                          onChange={e => setPartnerId(e.value)}
                        />
                      </div>


                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Wallet Balance</Trans>
                        </Label>
                        <Input
                          name="walletBalance"
                          value={walletBalance}
                          className="form-control"
                          placeholder=""
                          type="text"
                          disabled
                        ></Input>
                      </div>


                      <div className="form-group col-md-2 mt-2">
                        <Label className="form-label">
                          <Trans>Status</Trans>
                        </Label>
                        <div className="form-check form-check-end">
                          <FormGroup switch>
                            <Input
                              type="switch"
                              size="md"
                              checked={status == 2}
                              onClick={() => {
                                handleToggleCheckBox("setStatus")
                              }}
                            />
                          </FormGroup>
                        </div>
                      </div>
                    </Row>
                    <div className="mt-4">
                      <Button
                        type="button"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={loading}
                      >
                        <Trans>{loading ? "Processing..." : "Submit"}</Trans>
                      </Button>
                      &nbsp;

                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AddCollector
